import { n as normalizeComponent } from './normalize-component.js';

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  props: ['entityData'],
  computed: {
    imageUrl: function imageUrl() {
      return this.$xp.content.getImageUrl(this.entityData.Image);
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "c-news-entity" }, [
    _c("div", { staticClass: "c-news-entity__image" }, [
      _vm.entityData.Image.BinaryID
        ? _c("img", {
            attrs: { src: _vm.imageUrl, title: _vm.entityData.Image.Alt }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.entityData.Image.Caption.length > 0
        ? _c("div", { staticClass: "c-news-entity__image-caption" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.entityData.Image.Caption) +
                "\n        "
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "c-news-entity_meta" }, [
      _c("span", [
        _c("i", { staticClass: "xp xp-calendar" }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm._f("dateString")(_vm.entityData.Date)))])
      ]),
      _vm._v(" "),
      _vm.entityData.ShowTime
        ? _c("span", [
            _c("i", { staticClass: "xp xp-clock-o" }),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm._f("timeString")(_vm.entityData.Date)))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.entityData.Location.length > 0
        ? _c("span", [
            _c("i", { staticClass: "xp xp-map-marker" }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.entityData.Location))])
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", {
      staticClass: "c-news-entity__teaser",
      domProps: { innerHTML: _vm._s(_vm.entityData.Teaser) }
    })
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
//# sourceMappingURL=NewsEntity.js.map
